import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const CustomerList = Loadable(lazy(() => import("./CustomerList")));
const CustomerForm = Loadable(lazy(() => import("./CustomerForm")));

const customerRoutes = [
  { path: "/Customer/CustomerList", element: <CustomerList />, permission: PERMISSIONS.Customers.Menu },
  { path: "/Customer/CustomerForm", element: <CustomerForm /> },
  { path: "/Customer/CustomerForm/:customerId", element: <CustomerForm /> },
];

export default customerRoutes;
